import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as reduxForm } from 'redux-form';

import Common from './Common';

import AuthReducer from './AuthReducer';
import NotifyReducer from './NotifyReducer';
import NotificationReducer from './NotificationReducer';
import FilterReducer from './FilterReducer';
import DealerReducer from './DealerReducer';
import TicketReducer from './TicketReducer';
import UserReducer from './UserReducer';
import ReportReducer from './ReportReducer';

export default history =>
  combineReducers({
    router: connectRouter(history),
    common: Common,
    notify: NotifyReducer,
    notification: NotificationReducer,
    filter: FilterReducer,
    auth: AuthReducer,
    user: UserReducer,
    dealer: DealerReducer,
    ticket: TicketReducer,
    report: ReportReducer,
    form: reduxForm,
  });
